import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRevokeApprovalMutation } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';
import { useCaptureError } from '../useCaptureError';
import { useRevokeApprovalCallback } from '../../contexts/RevokeApprovalCallbackContext';
import { useTracking } from '../../contexts/TrackingContext';
import { EVENTS, SCREENS, ACTIONS } from '../../constants/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export function useRevokeApproval() {
  const {
    appId,
    appName
  } = useApp();
  const {
    onRevokeApproval
  } = useRevokeApprovalCallback();
  const {
    track
  } = useTracking();
  const [revokeApproval, {
    error,
    loading
  }] = useRevokeApprovalMutation({
    variables: {
      appId
    },
    onCompleted: () => {
      track(EVENTS.PANEL_INTERACTED, {
        screen: SCREENS.MANAGEMENT_MODAL_PANEL,
        action: ACTIONS.APP_REVOKED,
        appId,
        appName
      });
      onRevokeApproval === null || onRevokeApproval === void 0 || onRevokeApproval(appId);
    }
  });
  useCaptureError(error, {
    message: 'Error revoking approval',
    extra: {
      appId
    },
    alert: {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.errorBoundary.default.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.revokeApproval.error",
        options: {
          appName
        }
      })
    }
  });
  return {
    revokeApproval,
    error,
    loading
  };
}